import DeleteAccountForm from "../components/DeleteAccountForm/DeleteAccountForm";
import Heading from "../components/Heading/Heading";
import UnderMaintenanceOrChildren from "../components/UnderMaintenanceOrChildren/UnderMaintenanceOrChildren";
import useNavigation from "../hooks/navigation";

import style from "./AccountDeletionPage.module.css";

const AccountDeletionPage = () => {
  const navigation = useNavigation();
  return (
    <UnderMaintenanceOrChildren>
      <div className={style.container}>
        <div className={style.formContainer}>
          <Heading type="h1">Are you sure?</Heading>
          <DeleteAccountForm
            onCancel={() => {
              navigation.goToProfile();
            }}
          ></DeleteAccountForm>
        </div>
      </div>
    </UnderMaintenanceOrChildren>
  );
};

export default AccountDeletionPage;
